/* eslint-disable */
export class VehicleConfig {
    configId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    image: string | undefined;
    typeId: number | undefined;
}